const map = {
	"./bottom.png": 23093,
	"./discharged.png": 72512,
	"./doc.png": 50980,
	"./false.png": 53203,
	"./favicon.png": 53070,
	"./fingerprint.png": 43026,
	"./fingerprintError.png": 59650,
	"./fingerprintMatched.png": 23348,
	"./fingerprintNotMatched.png": 41047,
	"./login_right.png": 88066,
	"./logo.png": 30317,
	"./lost_password.png": 21236,
	"./noData.png": 54925,
	"./not_found.png": 61768,
	"./patient.png": 88713,
	"./round-avatar.png": 20554,
	"./top.png": 56543,
	"./true.png": 16708,
	"./user.png": 47701,
	"Assets/img/bottom.png": 23093,
	"Assets/img/discharged.png": 72512,
	"Assets/img/doc.png": 50980,
	"Assets/img/false.png": 53203,
	"Assets/img/favicon.png": 53070,
	"Assets/img/fingerprint.png": 43026,
	"Assets/img/fingerprintError.png": 59650,
	"Assets/img/fingerprintMatched.png": 23348,
	"Assets/img/fingerprintNotMatched.png": 41047,
	"Assets/img/login_right.png": 88066,
	"Assets/img/logo.png": 30317,
	"Assets/img/lost_password.png": 21236,
	"Assets/img/noData.png": 54925,
	"Assets/img/not_found.png": 61768,
	"Assets/img/patient.png": 88713,
	"Assets/img/round-avatar.png": 20554,
	"Assets/img/top.png": 56543,
	"Assets/img/true.png": 16708,
	"Assets/img/user.png": 47701
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76625;